import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LocalStorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class CmdNameManagerService {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService
  ) {
    this.initializeCmdNameTracking();
  }

  private initializeCmdNameTracking(): void {
    // Escutar mudanças de rota
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        // Verificar se há cmdName nos query parameters da URL atual
        this.checkAndUpdateCmdName();
      });
  }

  private checkAndUpdateCmdName(): void {
    // Obter query parameters da rota atual
    this.route.queryParams.subscribe(params => {
      if (params['cmdName']) {
        // Atualizar cmdNameActually no localStorage
        this.localStorageService.setCmdNameActually(params['cmdName']);
        console.log('CmdName atualizado no localStorage:', params['cmdName']);
      }
    });
  }

  // Método para atualizar cmdName manualmente
  public updateCmdName(cmdName: string): void {
    this.localStorageService.setCmdNameActually(cmdName);
  }

  // Método para obter cmdName atual
  public getCurrentCmdName(): string {
    return this.localStorageService.getCmdNameActually();
  }

  // Método para limpar cmdName
  public clearCmdName(): void {
    this.localStorageService.clearCmdNameActually();
  }
}
